import script from "./ProductDetail.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProductDetail.vue?vue&type=script&lang=ts&setup=true"

import "./ProductDetail.vue?vue&type=style&index=0&id=4810d5c9&lang=scss&scoped=true"
import "./ProductDetail.vue?vue&type=style&index=1&id=4810d5c9&lang=scss"

import exportComponent from "C:\\Users\\Arco\\Documents\\Git\\unifix\\unifix-web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4810d5c9"]])

export default __exports__